import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-main-menu',
    standalone: true,
    templateUrl: './main-menu.component.html',
    imports: [PanelMenuModule, NgIf, RouterModule]
})
export class MainMenuComponent implements OnInit {

    public items: MenuItem[] | any = [];

    constructor(private _dialogRef: DynamicDialogRef,
                private _cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
        this._initializeMenuItems();
    }

    private _initializeMenuItems(): void {
        this.items = [
            {
                label: 'Inicio',
                routerLink: '/',
                icon: 'bi bi-house',
                expanded: false,
                command: () => this._closeDialog()
            },
            {
                label: 'Mapa',
                icon: 'bi bi-geo-alt',
                routerLink: '/map',
                expanded: false,
                command: () => this._closeDialog()
            },
            {
                label: 'Proyectos',
                icon: 'bi bi-database',
                routerLink: '/projects',
                expanded: false,
                command: () => this._closeDialog()
            }
        ];
    }

    private _closeDialog() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this._dialogRef.close();
        this._cdr.detectChanges();
    }
}
